@if (!dataLoaded) {
  <p>{{ "LOADING" | translate }}...</p>
}

@if (moveSuccess) {
  <div class="alert alert-success positionAbs placeTopAndFade">
    {{ "NEW_STAFFS_MOVED" | translate }}
  </div>
}

@if (moveFailed) {
  <div class="alert alert-danger positionAbs placeTopAndFade">
    {{ "NEW_STAFFS_MOVED_FAILED" | translate }}
  </div>
}

@if (warningsCompany) {
  <div class="alert alert-danger positionAbs placeTopAndFade">
    {{ "NOT_ALL_STAFF_HAS_COMPANY" | translate }}
  </div>
}

@if (warningsRole) {
  <div class="alert alert-danger positionAbs placeBelowAndFade">
    {{ "NOT_ALL_STAFF_HAS_ROLE" | translate }}
  </div>
}

@if (deleteFailed) {
  <div class="alert alert-danger positionAbs placeTopAndFade">
    {{ "COMPANY_DELETE_ERROR" | translate }}
  </div>
}

<div class="mt-3" [hidden]="!dataLoaded">
  <h3 class="mb-3">{{ "STAFF" | translate }}</h3>

  <div class="d-flex justify-content-between align-items-center mb-3">
    <div class="d-flex align-items-center">
    <!-- Staff type selector -->
    <div class="view-toggle mr-2" role="group" [attr.aria-label]="'STAFF' | translate">
      <button
        type="button"
        class="view-toggle-option"
        [class.selected]="!showNonFederated"
        [attr.aria-pressed]="!showNonFederated"
        (click)="showNonFederated = false; loadFederatedStaff()">
        {{ "FEDERATED_STAFF" | translate }}
      </button>
      <button
        type="button"
        class="view-toggle-option"
        [class.selected]="showNonFederated"
        [attr.aria-pressed]="showNonFederated"
        (click)="showNonFederated = true; loadNonFederatedStaff()">
        {{ "NON_FEDERATED_STAFF" | translate }}
      </button>
    </div>
    <button 
    *ngIf="showNonFederated"
    class="btn btn-primary"
    (click)="openCreateUser()"
  >
    {{ "ADD_NEW_USER" | translate }}
  </button>
  </div>
    <div class="d-flex align-items-start justify-content-end">
      @if (sorting) {
        <div class="showSpinner">
          <i class="fad fa-spinner-third fa-spin"></i>
        </div>
      }

      <mat-form-field appearance="outline" class="mx-2">
        <mat-label>{{ "SORT_BY" | translate }}</mat-label>
        <mat-select [(ngModel)]="selectedSort">
          <mat-option [value]="0" class="hideMatOptionCheckbox" (click)="sortStaff()">
            {{ "ANY" | translate }}
          </mat-option>

          <mat-option [value]="-1" class="hideMatOptionCheckbox" (click)="sortStaff()">
            {{ "LATEST_FIRST" | translate }}
          </mat-option>

          <mat-option [value]="1" class="hideMatOptionCheckbox" (click)="sortStaff()">
            {{ "OLDEST_FIRST" | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <form (ngSubmit)="searchStaff()" class="table-search" role="search">
        <div class="input-group">
          <input
            #staffSearchInput
            class="form-control"
            type="text"
            [attr.aria-label]="'SEARCH' | translate"
            placeholder="{{ 'SEARCH' | translate }}..." />
          <div class="input-group-append">
            <button class="btn btn-primary" type="submit">
              {{ "SEARCH" | translate }}
            </button>
          </div>
        </div>
      </form>
      </div>
    </div>

    <div class="d-flex align-items-baseline">
      <div class="m-2" data-testid="totalItems_Top">{{ "ITEMS" | translate }}: {{ totalItems }}</div>

      <mat-paginator
        #paginatorTop
        class="ml-2 mb-1"
        [showFirstLastButtons]="true"
        [length]="totalItems"
        [pageIndex]="currentPageIndex"
        [pageSize]="pageSize"
        [pageSizeOptions]="staffFilter ? null : [25, 50, 75, 100]"
        (page)="paginatorBottom.pageIndex = $event.pageIndex; handlePageEvent($event)"
        aria-label="Select page">
      </mat-paginator>
    </div>

    <div class="container-fluid m-0 p-0 main">
      <div class="row">
        <div [ngClass]="editNewStaff ? 'col-xl-7' : 'col-9'" style="overflow-x: auto">
          @if (activeStaffList.length > 0) {
            <table
              class="mb-3"
              data-testid="table">
              <thead class="border-bottom">
                <tr>
                  <th>{{ "STAFF_NAME" | translate }}</th>
                  <th>{{ "STAFF_ID" | translate }}</th>
                  <th>{{ "ROLE" | translate }}</th>
                  <th>{{ "DATE_ADDED" | translate }}</th>
                  <th>{{ "CLIENTS" | translate }}</th>
                </tr>
              </thead>
              <tbody>
                @for (staff of activeStaffList; track staff; let i = $index) {
                  <tr
                    (click)="rowClicked(staff)"
                    [ngStyle]="{ 'background-color': staff.identityId === jobholder?.identityId && jobholder?.checked ? '#ECEDF0' : null }"
                    data-testid="table_row">
                    <td innerHTML="{{ (staff.firstName + ' ' + staff.familyName) | highlight : staffFilter }}">
                    </td>
                    <td innerHTML="{{ staff.identityId.split('%')[1] | highlight : staffFilter }}"></td>
                    <td>{{ (staff.staffRole === 0 || staff.staffRole === 5) ? "User" : (staff.staffRole === 95 || staff.staffRole === 130) ? "Landing page user" : null
                    }}</td>
                    <td innerHTML="{{ staff.createTime | moment:'L LTS' | highlight : staffFilter }}"></td>
                    <td>
                      @if (staff.locationList.length <= 1) {
                        <span>{{ staff.locationList.length === 1 ?
                        staff.locationList[0] : "-" }}</span>
                      }
                      @if (staff.locationList.length > 1) {
                        <span>
                          <span class="locationBadge">{{ staff.locationList.length }}</span>&nbsp;{{
                          "CLIENTS_FINNISH_ALT" | translate }}
                        </span>
                      }
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          } @else {
            <div class="row ml-5" data-testid="no_staff_found">
              {{ "STAFF_NOT_FOUND" | translate }}
            </div>
          }
        </div>

        @if (editNewStaff) {
          <div class="col-12 col-xl-5">
            <app-new-staff-edit
              [staff]="jobholder"
              [customers]="customers"
              [isCreateMode]="isCreateMode"
              [mode]="showNonFederated ? 'non-federated' : 'federated'"
              (onRemoveCompany)="completeRemovingCompany($event)"
              (onAddCompany)="finishAddingCompany()"
              (onMovingSelected)="moveSelected($event)"
              (onDeleteFailed)="notifyOnDeleteFailed()"
              (onCloseEditCard)="closeEditCard()"></app-new-staff-edit>
          </div>
        }
      </div>

    </div>

    <div class="d-flex align-items-baseline" [hidden]="activeStaffList.length < 5">
      <div class="m-2" data-testid="totalItems_Bottom">{{ "ITEMS" | translate }}: {{ totalItems }}</div>
      <mat-paginator
        #paginatorBottom
        class="ml-2 mb-3"
        [showFirstLastButtons]="true"
        [length]="totalItems"
        [pageSize]="pageSize"
        [pageSizeOptions]="staffFilter ? null : [25, 50, 75, 100]"
        (page)="paginatorTop.pageIndex = $event.pageIndex; handlePageEvent($event)"
        aria-label="Select page">
      </mat-paginator>
    </div>
  </div>